import classNames from 'classnames'

import style from './index.module.scss'

const Icon = ({
  name,
  size = 'md',
  classes= [],
  ...rest
}) => {
  return (
    <i
      className={
        classNames(
          style.icon,
          style[name],
          style[size],
          classes && classes.map(el => style[el] || el),
        )
      }
      {...rest}
    />
  )
}

export default Icon
